import dayjs, { Dayjs } from "dayjs";
import { attempt } from "./attempt";

const invalidDate = dayjs(null);

export const parseDate = (date: string): Dayjs => attempt(() => dayjs(date), invalidDate, "[createDate]");
export const formatDate = (date: string): string => attempt(() => dayjs(date).format("YYYY-MM-DD"), "", "[formatDate]");
export const dateOrUndefined = (value?: string | null): dayjs.Dayjs | undefined =>
  value ? parseDate(value) : undefined;
